import ScheduleIcon from "@mui/icons-material/Schedule";
import { Checkbox, Chip, TableCell, TableRow, Tooltip } from "@mui/material";
import { ICampanha, StatusCampanha } from "../../interfaces/ICampanha";
import { useDataHora } from "../../../core/hooks/useDataHora";

const statusColor: Record<StatusCampanha, "default" | "primary" | "success" | "warning" | "error"> = {
    RASCUNHO: "default",
    AGENDADA: "primary",
    ATIVA: "success",
    PAUSADA: "warning",
    FINALIZADA: "default",
    CANCELADA: "error",
    FALHA: "error"
};

const statusLabel: Record<StatusCampanha, string> = {
    RASCUNHO: "Rascunho",
    AGENDADA: "Agendada",
    ATIVA: "Ativa",
    PAUSADA: "Pausada",
    FINALIZADA: "Finalizada",
    CANCELADA: "Cancelada",
    FALHA: "Falha"
};

interface Props {
    campanha: ICampanha;
    selecionada: boolean;
    onToggleSelecionada: (campanha: ICampanha) => void;
    onVerResumo: (campanha: ICampanha) => void;
}

export const CampanhaTableRow = ({ campanha, selecionada, onToggleSelecionada, onVerResumo }: Props) => {
    const { dataHoraBr } = useDataHora();
    const status = campanha.status ?? "RASCUNHO";

    const data = (valor?: string | Date | null) => {
        if(!valor) return "-";
        const texto = typeof valor === "string" ? valor : valor.toISOString();
        return dataHoraBr(texto);
    };

    const chip = (
        <Chip
            label={statusLabel[status]}
            color={statusColor[status]}
            size="small"
            icon={status === "AGENDADA" ? <ScheduleIcon /> : undefined}
        />
    );

    return (
        <TableRow hover selected={selecionada}>
            <TableCell padding="checkbox">
                <Checkbox checked={selecionada} onChange={() => onToggleSelecionada(campanha)} />
            </TableCell>
            <TableCell
                onClick={() => onVerResumo(campanha)}
                sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
            >
                {campanha.nome}
            </TableCell>
            <TableCell>
                {status === "AGENDADA" && campanha.inicioAs ? (
                    <Tooltip title={`Ativa automaticamente em ${data(campanha.inicioAs)}`} arrow>
                        {chip}
                    </Tooltip>
                ) : chip}
            </TableCell>
            <TableCell>{data(campanha.inicioAs)}</TableCell>
            <TableCell>{data(campanha.terminoAs)}</TableCell>
            <TableCell>{campanha.itens?.length ?? 0}</TableCell>
        </TableRow>
    );
};
